<script>
import { restoreUserSession } from '@shared/utils/sessionHandover'

export default {
  methods: {
    restoreUserSession() {
      return restoreUserSession()
    }
  }
}
</script>
